export const regions = {
    AT: [
        {
            active: true,
            ISOCode: '1',
            Name: 'Burgenland',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '2',
            Name: 'Kärnten',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '3',
            Name: 'Niederösterreich',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '4',
            Name: 'Oberösterreich',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '5',
            Name: 'Salzburg',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '6',
            Name: 'Steiermark',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '7',
            Name: 'Tirol',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '8',
            Name: 'Vorarlberg',
            CountryRegion: 'Austria [AT]',
        },
        {
            active: true,
            ISOCode: '9',
            Name: 'Wien',
            CountryRegion: 'Austria [AT]',
        },
    ],
    BE: [
        {
            active: true,
            ISOCode: 'VAN',
            Name: 'Antwerpen',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'WBR',
            Name: 'Brabant wallon',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'BRU',
            Name: 'Bruxelles-Capitale',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'WHT',
            Name: 'Hainaut',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'VLI',
            Name: 'Limburg',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'WLG',
            Name: 'Liège / Lüttich',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'WLX',
            Name: 'Luxembourg',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'WNA',
            Name: 'Namur',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'VOV',
            Name: 'Oost-Vlaanderen',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'VBR',
            Name: 'Vlaams-Brabant',
            CountryRegion: 'Belgium [BE]',
        },
        {
            active: true,
            ISOCode: 'VWV',
            Name: 'West-Vlaanderen',
            CountryRegion: 'Belgium [BE]',
        },
    ],
    CH: [
        {
            active: true,
            ISOCode: 'AG',
            Name: 'Aargau',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'AR',
            Name: 'Appenzell Ausserrhoden',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'AI',
            Name: 'Appenzell Innerrhoden',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'BL',
            Name: 'Basel-Landschaft',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'BS',
            Name: 'Basel-Stadt',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'BE',
            Name: 'Bern / Berne',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'FR',
            Name: 'Fribourg / Freiburg',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'GE',
            Name: 'Genève',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'GL',
            Name: 'Glarus',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'GR',
            Name: 'Graubünden / Grigioni / Grischun',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'JU',
            Name: 'Jura',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'LU',
            Name: 'Luzern',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'NE',
            Name: 'Neuchâtel',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'NW',
            Name: 'Nidwalden',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'OW',
            Name: 'Obwalden',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'SH',
            Name: 'Schaffhausen',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'SZ',
            Name: 'Schwyz',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'SO',
            Name: 'Solothurn',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'SG',
            Name: 'St. Gallen',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'TG',
            Name: 'Thurgau',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'TI',
            Name: 'Ticino',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'UR',
            Name: 'Uri',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'VS',
            Name: 'Valais / Wallis',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'VD',
            Name: 'Vaud',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'ZG',
            Name: 'Zug',
            CountryRegion: 'Switzerland [CH]',
        },
        {
            active: true,
            ISOCode: 'ZH',
            Name: 'Zürich',
            CountryRegion: 'Switzerland [CH]',
        },
    ],
    CZ: [
        {
            active: true,
            ISOCode: '64',
            Name: 'Jihomoravský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '31',
            Name: 'Jihočeský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '41',
            Name: 'Karlovarský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '63',
            Name: 'Kraj Vysočina',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '52',
            Name: 'Královéhradecký kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '51',
            Name: 'Liberecký kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '80',
            Name: 'Moravskoslezský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '71',
            Name: 'Olomoucký kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '53',
            Name: 'Pardubický kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '32',
            Name: 'Plzeňský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '20',
            Name: 'Středočeský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '72',
            Name: 'Zlínský kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '42',
            Name: 'Ústecký kraj',
            CountryRegion: 'Czech Republic [CZ]',
        },
        {
            active: true,
            ISOCode: '10',
            Name: 'Praha, Hlavní město',
            CountryRegion: 'Czech Republic [CZ]',
        },
    ],
    DE: [
        {
            active: true,
            ISOCode: 'BW',
            Name: 'Baden-Württemberg',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'BY',
            Name: 'Bayern',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'BE',
            Name: 'Berlin',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'BB',
            Name: 'Brandenburg',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'HB',
            Name: 'Bremen',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'HH',
            Name: 'Hamburg',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'HE',
            Name: 'Hessen',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'MV',
            Name: 'Mecklenburg-Vorpommern',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'NI',
            Name: 'Niedersachsen',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'NW',
            Name: 'Nordrhein-Westfalen',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'RP',
            Name: 'Rheinland-Pfalz',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'SL',
            Name: 'Saarland',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'SN',
            Name: 'Sachsen',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'ST',
            Name: 'Sachsen-Anhalt',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'SH',
            Name: 'Schleswig-Holstein',
            CountryRegion: 'Germany [DE]',
        },
        {
            active: true,
            ISOCode: 'TH',
            Name: 'Thüringen',
            CountryRegion: 'Germany [DE]',
        },
    ],
    DK: [
        {
            active: true,
            ISOCode: '84',
            Name: 'Hovedstaden',
            CountryRegion: 'Denmark [DK]',
        },
        {
            active: true,
            ISOCode: '82',
            Name: 'Midtjylland',
            CountryRegion: 'Denmark [DK]',
        },
        {
            active: true,
            ISOCode: '81',
            Name: 'Nordjylland',
            CountryRegion: 'Denmark [DK]',
        },
        {
            active: true,
            ISOCode: '85',
            Name: 'Sjælland',
            CountryRegion: 'Denmark [DK]',
        },
        {
            active: true,
            ISOCode: '83',
            Name: 'Syddanmark',
            CountryRegion: 'Denmark [DK]',
        },
    ],
    ES: [
        {
            active: true,
            ISOCode: 'C',
            Name: 'A Coruña',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'A',
            Name: 'Alacant',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'AB',
            Name: 'Albacete',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'AL',
            Name: 'Almería',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'VI',
            Name: 'Araba',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'O',
            Name: 'Asturias',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'BA',
            Name: 'Badajoz',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'B',
            Name: 'Barcelona',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'BI',
            Name: 'Bizkaia',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'BU',
            Name: 'Burgos',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'S',
            Name: 'Cantabria',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'CS',
            Name: 'Castelló',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'CR',
            Name: 'Ciudad Real',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'CU',
            Name: 'Cuenca',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'CC',
            Name: 'Cáceres',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'CA',
            Name: 'Cádiz',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'CO',
            Name: 'Córdoba',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'SS',
            Name: 'Gipuzkoa',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'GI',
            Name: 'Girona',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'GR',
            Name: 'Granada',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'GU',
            Name: 'Guadalajara',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'H',
            Name: 'Huelva',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'HU',
            Name: 'Huesca',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'IB',
            Name: 'Illes Balears',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'J',
            Name: 'Jaén',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'LO',
            Name: 'La Rioja',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'GC',
            Name: 'Las Palmas',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'LE',
            Name: 'León',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'L',
            Name: 'Lleida',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'LU',
            Name: 'Lugo',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'M',
            Name: 'Madrid',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'MU',
            Name: 'Murcia',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'MA',
            Name: 'Málaga',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'NA',
            Name: 'Nafarroa',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'OR',
            Name: 'Ourense',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'P',
            Name: 'Palencia',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'PO',
            Name: 'Pontevedra',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'SA',
            Name: 'Salamanca',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'TF',
            Name: 'Santa Cruz de Tenerife',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'SG',
            Name: 'Segovia',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'SE',
            Name: 'Sevilla',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'SO',
            Name: 'Soria',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'T',
            Name: 'Tarragona',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'TE',
            Name: 'Teruel',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'TO',
            Name: 'Toledo',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'VA',
            Name: 'Valladolid',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'V',
            Name: 'València',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'ZA',
            Name: 'Zamora',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'Z',
            Name: 'Zaragoza',
            CountryRegion: 'Spain [ES]',
        },
        {
            active: true,
            ISOCode: 'AV',
            Name: 'Ávila',
            CountryRegion: 'Spain [ES]',
        },
    ],
    FI: [
        {
            active: true,
            ISOCode: '01',
            Name: 'Ahvenanmaan maakunta',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '02',
            Name: 'Etelä-Karjala',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '03',
            Name: 'Etelä-Pohjanmaa',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '04',
            Name: 'Etelä-Savo',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '05',
            Name: 'Kainuu',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '06',
            Name: 'Kanta-Häme',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '07',
            Name: 'Keski-Pohjanmaa',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '08',
            Name: 'Keski-Suomi',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '09',
            Name: 'Kymenlaakso',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '10',
            Name: 'Lappi',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '11',
            Name: 'Pirkanmaa',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '12',
            Name: 'Pohjanmaa',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '13',
            Name: 'Pohjois-Karjala',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '14',
            Name: 'Pohjois-Pohjanmaa',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '15',
            Name: 'Pohjois-Savo',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '16',
            Name: 'Päijät-Häme',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '17',
            Name: 'Satakunta',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '18',
            Name: 'Uusimaa',
            CountryRegion: 'Finland [FI]',
        },
        {
            active: true,
            ISOCode: '19',
            Name: 'Varsinais-Suomi',
            CountryRegion: 'Finland [FI]',
        },
    ],
    FR: [
        {
            active: true,
            ISOCode: '01',
            Name: 'Ain',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '02',
            Name: 'Aisne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '03',
            Name: 'Allier',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '04',
            Name: 'Alpes-de-Haute-Provence',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '06',
            Name: 'Alpes-Maritimes',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '08',
            Name: 'Ardennes',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '07',
            Name: 'Ardèche',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '09',
            Name: 'Ariège',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '10',
            Name: 'Aube',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '11',
            Name: 'Aude',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '12',
            Name: 'Aveyron',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '67',
            Name: 'Bas-Rhin',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '13',
            Name: 'Bouches-du-Rhône',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '14',
            Name: 'Calvados',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '15',
            Name: 'Cantal',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '16',
            Name: 'Charente',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '17',
            Name: 'Charente-Maritime',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '18',
            Name: 'Cher',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '19',
            Name: 'Corrèze',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '2A',
            Name: 'Corse-du-Sud',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '23',
            Name: 'Creuse',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '21',
            Name: "Côte-d'Or",
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '22',
            Name: "Côtes-d'Armor",
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '79',
            Name: 'Deux-Sèvres',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '24',
            Name: 'Dordogne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '25',
            Name: 'Doubs',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '26',
            Name: 'Drôme',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '91',
            Name: 'Essonne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '27',
            Name: 'Eure',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '28',
            Name: 'Eure-et-Loir',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '29',
            Name: 'Finistère',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '30',
            Name: 'Gard',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '32',
            Name: 'Gers',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '33',
            Name: 'Gironde',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '68',
            Name: 'Haut-Rhin',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '2B',
            Name: 'Haute-Corse',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '31',
            Name: 'Haute-Garonne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '43',
            Name: 'Haute-Loire',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '52',
            Name: 'Haute-Marne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '74',
            Name: 'Haute-Savoie',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '70',
            Name: 'Haute-Saône',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '87',
            Name: 'Haute-Vienne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '05',
            Name: 'Hautes-Alpes',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '65',
            Name: 'Hautes-Pyrénées',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '92',
            Name: 'Hauts-de-Seine',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '34',
            Name: 'Hérault',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '35',
            Name: 'Ille-et-Vilaine',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '36',
            Name: 'Indre',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '37',
            Name: 'Indre-et-Loire',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '38',
            Name: 'Isère',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '39',
            Name: 'Jura',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '40',
            Name: 'Landes',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '41',
            Name: 'Loir-et-Cher',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '42',
            Name: 'Loire',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '44',
            Name: 'Loire-Atlantique',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '45',
            Name: 'Loiret',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '46',
            Name: 'Lot',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '47',
            Name: 'Lot-et-Garonne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '48',
            Name: 'Lozère',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '49',
            Name: 'Maine-et-Loire',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '50',
            Name: 'Manche',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '51',
            Name: 'Marne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '53',
            Name: 'Mayenne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '54',
            Name: 'Meurthe-et-Moselle',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '55',
            Name: 'Meuse',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '56',
            Name: 'Morbihan',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '57',
            Name: 'Moselle',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '58',
            Name: 'Nièvre',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '59',
            Name: 'Nord',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '60',
            Name: 'Oise',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '61',
            Name: 'Orne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '75C',
            Name: 'Paris',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '62',
            Name: 'Pas-de-Calais',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '63',
            Name: 'Puy-de-Dôme',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '64',
            Name: 'Pyrénées-Atlantiques',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '66',
            Name: 'Pyrénées-Orientales',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '69',
            Name: 'Rhône',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '72',
            Name: 'Sarthe',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '73',
            Name: 'Savoie',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '71',
            Name: 'Saône-et-Loire',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '77',
            Name: 'Seine-et-Marne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '76',
            Name: 'Seine-Maritime',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '93',
            Name: 'Seine-Saint-Denis',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '80',
            Name: 'Somme',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '81',
            Name: 'Tarn',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '82',
            Name: 'Tarn-et-Garonne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '90',
            Name: 'Territoire de Belfort',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '95',
            Name: "Val-d'Oise",
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '94',
            Name: 'Val-de-Marne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '83',
            Name: 'Var',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '84',
            Name: 'Vaucluse',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '85',
            Name: 'Vendée',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '86',
            Name: 'Vienne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '88',
            Name: 'Vosges',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '89',
            Name: 'Yonne',
            CountryRegion: 'France [FR]',
        },
        {
            active: true,
            ISOCode: '78',
            Name: 'Yvelines',
            CountryRegion: 'France [FR]',
        },
    ],
    GR: [
        {
            active: true,
            ISOCode: '69',
            Name: 'Άγιον Όρος',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'D',
            Name: 'Ήπειρος',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'A',
            Name: 'Ανατολική Μακεδονία και Θράκη',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'I',
            Name: 'Αττική',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'K',
            Name: 'Βόρειο Αιγαίο',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'G',
            Name: 'Δυτική Ελλάδα',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'C',
            Name: 'Δυτική Μακεδονία',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'E',
            Name: 'Θεσσαλία',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'F',
            Name: 'Ιόνια Νησιά',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'B',
            Name: 'Κεντρική Μακεδονία',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'M',
            Name: 'Κρήτη',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'L',
            Name: 'Νότιο Αιγαίο',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'J',
            Name: 'Πελοπόννησος',
            CountryRegion: 'Greece [GR]',
        },
        {
            active: true,
            ISOCode: 'H',
            Name: 'Στερεά Ελλάδα',
            CountryRegion: 'Greece [GR]',
        },
    ],
    HR: [
        {
            active: true,
            ISOCode: '07',
            Name: 'Bjelovarsko-bilogorska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '12',
            Name: 'Brodsko-posavska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '19',
            Name: 'Dubrovačko-neretvanska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '21',
            Name: 'Grad Zagreb',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '18',
            Name: 'Istarska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '04',
            Name: 'Karlovačka županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '06',
            Name: 'Koprivničko-križevačka županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '02',
            Name: 'Krapinsko-zagorska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '09',
            Name: 'Ličko-senjska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '20',
            Name: 'Međimurska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '14',
            Name: 'Osječko-baranjska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '11',
            Name: 'Požeško-slavonska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '08',
            Name: 'Primorsko-goranska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '03',
            Name: 'Sisačko-moslavačka županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '17',
            Name: 'Splitsko-dalmatinska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '05',
            Name: 'Varaždinska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '10',
            Name: 'Virovitičko-podravska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '16',
            Name: 'Vukovarsko-srijemska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '13',
            Name: 'Zadarska županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '01',
            Name: 'Zagrebačka županija',
            CountryRegion: 'Croatia [HR]',
        },
        {
            active: true,
            ISOCode: '15',
            Name: 'Šibensko-kninska županija',
            CountryRegion: 'Croatia [HR]',
        },
    ],
    HU: [
        {
            active: true,
            ISOCode: 'BA',
            Name: 'Baranya vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'BZ',
            Name: 'Borsod-Abaúj-Zemplén vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'BU',
            Name: 'Budapest főváros',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'BK',
            Name: 'Bács-Kiskun vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'BE',
            Name: 'Békés vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'CS',
            Name: 'Csongrád-Csanád vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'FE',
            Name: 'Fejér vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'GS',
            Name: 'Győr-Moson-Sopron vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'HB',
            Name: 'Hajdú-Bihar vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'HE',
            Name: 'Heves vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'JN',
            Name: 'Jász-Nagykun-Szolnok vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'KE',
            Name: 'Komárom-Esztergom vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'NO',
            Name: 'Nógrád vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'PE',
            Name: 'Pest vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'SO',
            Name: 'Somogy vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'SZ',
            Name: 'Szabolcs-Szatmár-Bereg vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'TO',
            Name: 'Tolna vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'VA',
            Name: 'Vas vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'VE',
            Name: 'Veszprém vármegye',
            CountryRegion: 'Hungary [HU]',
        },
        {
            active: true,
            ISOCode: 'ZA',
            Name: 'Zala vármegye',
            CountryRegion: 'Hungary [HU]',
        },
    ],
    IT: [
        {
            active: true,
            ISOCode: 'AG',
            Name: 'Agrigento',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AL',
            Name: 'Alessandria',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AN',
            Name: 'Ancona',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AO',
            Name: 'Aosta / Aoste',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AR',
            Name: 'Arezzo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AP',
            Name: 'Ascoli Piceno',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AT',
            Name: 'Asti',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AV',
            Name: 'Avellino',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BA',
            Name: 'Bari',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BT',
            Name: 'Barletta-Andria-Trani',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BL',
            Name: 'Belluno',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BN',
            Name: 'Benevento',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BG',
            Name: 'Bergamo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BI',
            Name: 'Biella',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BO',
            Name: 'Bologna',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BZ',
            Name: 'Bolzano / Bozen',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BS',
            Name: 'Brescia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'BR',
            Name: 'Brindisi',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CA',
            Name: 'Cagliari',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CL',
            Name: 'Caltanissetta',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CB',
            Name: 'Campobasso',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CE',
            Name: 'Caserta',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CT',
            Name: 'Catania',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CZ',
            Name: 'Catanzaro',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CH',
            Name: 'Chieti',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CO',
            Name: 'Como',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CS',
            Name: 'Cosenza',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CR',
            Name: 'Cremona',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'KR',
            Name: 'Crotone',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'CN',
            Name: 'Cuneo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'EN',
            Name: 'Enna',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'FM',
            Name: 'Fermo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'FE',
            Name: 'Ferrara',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'FI',
            Name: 'Firenze',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'FG',
            Name: 'Foggia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'FC',
            Name: 'Forlì-Cesena',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'FR',
            Name: 'Frosinone',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'GE',
            Name: 'Genova',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'GO',
            Name: 'Gorizia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'GR',
            Name: 'Grosseto',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'IM',
            Name: 'Imperia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'IS',
            Name: 'Isernia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'AQ',
            Name: "L'Aquila",
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SP',
            Name: 'La Spezia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'LT',
            Name: 'Latina',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'LE',
            Name: 'Lecce',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'LC',
            Name: 'Lecco',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'LI',
            Name: 'Livorno',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'LO',
            Name: 'Lodi',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'LU',
            Name: 'Lucca',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MC',
            Name: 'Macerata',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MN',
            Name: 'Mantova',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MS',
            Name: 'Massa-Carrara',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MT',
            Name: 'Matera',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'ME',
            Name: 'Messina',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MI',
            Name: 'Milano',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MO',
            Name: 'Modena',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'MB',
            Name: 'Monza e Brianza',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'NA',
            Name: 'Napoli',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'NO',
            Name: 'Novara',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'NU',
            Name: 'Nuoro',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'OR',
            Name: 'Oristano',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PD',
            Name: 'Padova',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PA',
            Name: 'Palermo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PR',
            Name: 'Parma',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PV',
            Name: 'Pavia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PG',
            Name: 'Perugia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PU',
            Name: 'Pesaro e Urbino',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PE',
            Name: 'Pescara',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PC',
            Name: 'Piacenza',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PI',
            Name: 'Pisa',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PT',
            Name: 'Pistoia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PN',
            Name: 'Pordenone',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PZ',
            Name: 'Potenza',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'PO',
            Name: 'Prato',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RG',
            Name: 'Ragusa',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RA',
            Name: 'Ravenna',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RC',
            Name: 'Reggio Calabria',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RE',
            Name: 'Reggio Emilia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RI',
            Name: 'Rieti',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RN',
            Name: 'Rimini',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RM',
            Name: 'Roma',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'RO',
            Name: 'Rovigo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SA',
            Name: 'Salerno',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SS',
            Name: 'Sassari',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SV',
            Name: 'Savona',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SI',
            Name: 'Siena',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SR',
            Name: 'Siracusa',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SO',
            Name: 'Sondrio',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'SU',
            Name: 'Sud Sardegna',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TA',
            Name: 'Taranto',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TE',
            Name: 'Teramo',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TR',
            Name: 'Terni',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TO',
            Name: 'Torino',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TP',
            Name: 'Trapani',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TN',
            Name: 'Trento',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TV',
            Name: 'Treviso',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'TS',
            Name: 'Trieste',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'UD',
            Name: 'Udine',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VA',
            Name: 'Varese',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VE',
            Name: 'Venezia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VB',
            Name: 'Verbano-Cusio-Ossola',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VC',
            Name: 'Vercelli',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VR',
            Name: 'Verona',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VV',
            Name: 'Vibo Valentia',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VI',
            Name: 'Vicenza',
            CountryRegion: 'Italy [IT]',
        },
        {
            active: true,
            ISOCode: 'VT',
            Name: 'Viterbo',
            CountryRegion: 'Italy [IT]',
        },
    ],
    LT: [
        {
            active: true,
            ISOCode: 'AL',
            Name: 'Alytaus apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'KU',
            Name: 'Kauno apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'KL',
            Name: 'Klaipėdos apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'MR',
            Name: 'Marijampolės apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'PN',
            Name: 'Panevėžio apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'TA',
            Name: 'Tauragės apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'TE',
            Name: 'Telšių apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'UT',
            Name: 'Utenos apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'VL',
            Name: 'Vilniaus apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
        {
            active: true,
            ISOCode: 'SA',
            Name: 'Šiaulių apskritis',
            CountryRegion: 'Lithuania [LT]',
        },
    ],
    NL: [
        {
            active: true,
            ISOCode: 'DR',
            Name: 'Drenthe',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'FL',
            Name: 'Flevoland',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'FR',
            Name: 'Fryslân',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'GE',
            Name: 'Gelderland',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'GR',
            Name: 'Groningen',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'LI',
            Name: 'Limburg',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'NB',
            Name: 'Noord-Brabant',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'NH',
            Name: 'Noord-Holland',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'OV',
            Name: 'Overijssel',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'UT',
            Name: 'Utrecht',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'ZE',
            Name: 'Zeeland',
            CountryRegion: 'Netherlands [NL]',
        },
        {
            active: true,
            ISOCode: 'ZH',
            Name: 'Zuid-Holland',
            CountryRegion: 'Netherlands [NL]',
        },
    ],
    NO: [
        {
            active: true,
            ISOCode: '42',
            Name: 'Agder',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '34',
            Name: 'Innlandet',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '22',
            Name: 'Jan Mayen',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '15',
            Name: 'Møre og Romsdal',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '18',
            Name: 'Nordland',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '03',
            Name: 'Oslo',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '11',
            Name: 'Rogaland',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '21',
            Name: 'Svalbard',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '54',
            Name: 'Troms og Finnmark',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '50',
            Name: 'Trøndelag',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '38',
            Name: 'Vestfold og Telemark',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '46',
            Name: 'Vestland',
            CountryRegion: 'Norway [NO]',
        },
        {
            active: true,
            ISOCode: '30',
            Name: 'Viken',
            CountryRegion: 'Norway [NO]',
        },
    ],
    PL: [
        {
            active: true,
            ISOCode: '02',
            Name: 'Dolnośląskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '04',
            Name: 'Kujawsko-pomorskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '06',
            Name: 'Lubelskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '08',
            Name: 'Lubuskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '14',
            Name: 'Mazowieckie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '12',
            Name: 'Małopolskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '16',
            Name: 'Opolskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '18',
            Name: 'Podkarpackie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '20',
            Name: 'Podlaskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '22',
            Name: 'Pomorskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '28',
            Name: 'Warmińsko-mazurskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '30',
            Name: 'Wielkopolskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '32',
            Name: 'Zachodniopomorskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '10',
            Name: 'Łódzkie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '24',
            Name: 'Śląskie',
            CountryRegion: 'Poland [PL]',
        },
        {
            active: true,
            ISOCode: '26',
            Name: 'Świętokrzyskie',
            CountryRegion: 'Poland [PL]',
        },
    ],
    PT: [
        {
            active: true,
            ISOCode: '01',
            Name: 'Aveiro',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '20',
            Name: 'Açores',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '02',
            Name: 'Beja',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '03',
            Name: 'Braga',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '04',
            Name: 'Bragança',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '05',
            Name: 'Castelo Branco',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '06',
            Name: 'Coimbra',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '08',
            Name: 'Faro',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '09',
            Name: 'Guarda',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '10',
            Name: 'Leiria',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '11',
            Name: 'Lisboa',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '30',
            Name: 'Madeira',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '12',
            Name: 'Portalegre',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '13',
            Name: 'Porto',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '14',
            Name: 'Santarém',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '15',
            Name: 'Setúbal',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '16',
            Name: 'Viana do Castelo',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '17',
            Name: 'Vila Real',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '18',
            Name: 'Viseu',
            CountryRegion: 'Portugal [PT]',
        },
        {
            active: true,
            ISOCode: '07',
            Name: 'Évora',
            CountryRegion: 'Portugal [PT]',
        },
    ],
    RO: [
        {
            active: true,
            ISOCode: 'AB',
            Name: 'Alba',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'AR',
            Name: 'Arad',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'AG',
            Name: 'Argeș',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BC',
            Name: 'Bacău',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BH',
            Name: 'Bihor',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BN',
            Name: 'Bistrița-Năsăud',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BT',
            Name: 'Botoșani',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BV',
            Name: 'Brașov',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BR',
            Name: 'Brăila',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'B',
            Name: 'București',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'BZ',
            Name: 'Buzău',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'CS',
            Name: 'Caraș-Severin',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'CJ',
            Name: 'Cluj',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'CT',
            Name: 'Constanța',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'CV',
            Name: 'Covasna',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'CL',
            Name: 'Călărași',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'DJ',
            Name: 'Dolj',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'DB',
            Name: 'Dâmbovița',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'GL',
            Name: 'Galați',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'GR',
            Name: 'Giurgiu',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'GJ',
            Name: 'Gorj',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'HR',
            Name: 'Harghita',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'HD',
            Name: 'Hunedoara',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'IL',
            Name: 'Ialomița',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'IS',
            Name: 'Iași',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'IF',
            Name: 'Ilfov',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'MM',
            Name: 'Maramureș',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'MH',
            Name: 'Mehedinți',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'MS',
            Name: 'Mureș',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'NT',
            Name: 'Neamț',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'OT',
            Name: 'Olt',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'PH',
            Name: 'Prahova',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'SM',
            Name: 'Satu Mare',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'SB',
            Name: 'Sibiu',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'SV',
            Name: 'Suceava',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'SJ',
            Name: 'Sălaj',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'TR',
            Name: 'Teleorman',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'TM',
            Name: 'Timiș',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'TL',
            Name: 'Tulcea',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'VS',
            Name: 'Vaslui',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'VN',
            Name: 'Vrancea',
            CountryRegion: 'Romania [RO]',
        },
        {
            active: true,
            ISOCode: 'VL',
            Name: 'Vâlcea',
            CountryRegion: 'Romania [RO]',
        },
    ],
    SE: [
        {
            active: true,
            ISOCode: 'K',
            Name: 'Blekinge län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'W',
            Name: 'Dalarnas län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'I',
            Name: 'Gotlands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'X',
            Name: 'Gävleborgs län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'N',
            Name: 'Hallands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'Z',
            Name: 'Jämtlands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'F',
            Name: 'Jönköpings län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'H',
            Name: 'Kalmar län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'G',
            Name: 'Kronobergs län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'BD',
            Name: 'Norrbottens län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'M',
            Name: 'Skåne län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'AB',
            Name: 'Stockholms län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'D',
            Name: 'Södermanlands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'C',
            Name: 'Uppsala län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'S',
            Name: 'Värmlands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'AC',
            Name: 'Västerbottens län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'Y',
            Name: 'Västernorrlands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'U',
            Name: 'Västmanlands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'O',
            Name: 'Västra Götalands län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'T',
            Name: 'Örebro län',
            CountryRegion: 'Sweden [SE]',
        },
        {
            active: true,
            ISOCode: 'E',
            Name: 'Östergötlands län',
            CountryRegion: 'Sweden [SE]',
        },
    ],
    SI: [
        {
            active: true,
            ISOCode: '009',
            Name: 'Gorenjska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '011',
            Name: 'Goriška',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '007',
            Name: 'Jugovzhodna Slovenija',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '003',
            Name: 'Koroška',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '012',
            Name: 'Obalno-kraška',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '008',
            Name: 'Osrednjeslovenska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '002',
            Name: 'Podravska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '001',
            Name: 'Pomurska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '006',
            Name: 'Posavska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '010',
            Name: 'Primorsko-notranjska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '004',
            Name: 'Savinjska',
            CountryRegion: 'Slovenia [SI]',
        },
        {
            active: true,
            ISOCode: '005',
            Name: 'Zasavska',
            CountryRegion: 'Slovenia [SI]',
        },
    ],
    SK: [
        {
            active: true,
            ISOCode: 'BC',
            Name: 'Banskobystrický kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'BL',
            Name: 'Bratislavský kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'KI',
            Name: 'Košický kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'NI',
            Name: 'Nitriansky kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'PV',
            Name: 'Prešovský kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'TC',
            Name: 'Trenčiansky kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'TA',
            Name: 'Trnavský kraj',
            CountryRegion: 'Slovakia [SK]',
        },
        {
            active: true,
            ISOCode: 'ZI',
            Name: 'Žilinský kraj',
            CountryRegion: 'Slovakia [SK]',
        },
    ],
}
